export default __webpack_public_path__ + "static/media/wordsearch_locked_crown.d22fa920.svg";